// import Vsicon from "../../Assets/Images/vsicon.png";
// import DAE from "../../Assets/Images/DAE.png";
// import CC_Eng from "../../Assets/Images/CC English.png";
// import CC_Mar from "../../Assets/Images/CC_Marathi.png";
// import Vessomag from "../../Assets/Images/Vessomag.png";
// import OtherImg from "../../Assets/Images/Other.png";

// const GalleryMore = () => {
//     const galleryData = [
//         { image: Vsicon, title: "Vsicon" },
//         { image: DAE, title: "DAE" },
//         { image: CC_Eng, title: "Climate Change English" },
//         { image: CC_Mar, title: "Climate Change Marathi" },
//         { image: Vessomag, title: "Vessomag" },
//         { image: OtherImg, title: "Other" }
//     ];

//     return (
//         <section className="gallery-more ">
//             <div className="container-fluid">
//                 <div className="row">
//                     {galleryData.map((item, index) => (
//                         <div className="col-md-4 g-5" key={index}>
//                             <div className="card bg-dark text-white position-relative border-0">
//                                 <img src={item.image} className="card-img" alt={item.title} />
//                                 <div className="card-img-overlay gallery-card  d-flex flex-column justify-content-center align-items-center text-center">
//                                     <h3 className="card-title">{item.title}</h3>
//                                     <p className="py-2 text-white">Click to see more images</p>
//                                     <a href="gallery-page" className="text-decoration-none">
//                                         <button className="btn click-here rounded-0 px-3 mb-4 border-white text-white">
//                                             Get In Touch
//                                         </button>
//                                     </a>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default GalleryMore;

import { useEffect, useState } from "react";
import axios from "../../axios";
import { Link } from "react-router-dom";

const GalleryMore = () => {
  const [galleries, setGalleries] = useState([]);

  useEffect(() => {
    axios
      .get("/gallery-folders") // ✅ NEW endpoint
      .then((res) => {
        setGalleries(res.data);
      })
      .catch((err) => {
        console.error("Error loading galleries", err);
      });
  }, []);

  return (
    <section className="gallery-more">
      <div className="container-fluid">
        <div className="row">
          {galleries.map((item, index) => (
            <div className="col-md-4 g-5" key={index}>
              <div className="card bg-dark text-white position-relative border-0">
                <img
                  src={item.cover_image}
                  className="card-img"
                  alt={item.title}
                />
                <div className="card-img-overlay gallery-card d-flex flex-column justify-content-center align-items-center text-center">
                  <h3 className="card-title">{item.title}</h3>
                  <p className="py-2 text-white">Click to see more images</p>
                  <Link
                    to={`/gallery-page/${item.event_id}`}
                    className="text-decoration-none">
                    <button className="btn click-here rounded-0 px-3 mb-4 border-white text-white">
                      Click Here
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryMore;
